































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { Unit, UserLogin } from "@/types";
import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";


@Component({ 
  components: { 
    VCDateTimePicker 
  } })
export default class ImplementasiMppInput extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: false }) readonly isReadonly!: boolean;

  private formError: any = {
    authored_at: null
  };
  
  private isInternalChange = false;

  unitRanapId = this.stateUser?.unit_id || null;
  unitRanap = this.stateUser?.unit || null;
  authored_at: string | Date = new Date();
  user: UserLogin | null = null;
  unit: Unit | null = null;
  perawatId: number | string | null = null;
  namaPerawat = "";
  implementasi = [];
  evaluasi = [];
  keterangan = "";
  saving = false;
  category = "implementasi";
  id = null;

  searchImplementasi = "";
  searchEvaluasi = "";

  selectedImplementasi = [];
  noteImplementasi = "";
  selectedEvaluasi = [];
  noteEvaluasi = "";

  optImplementasi = [
    { id: "1", text: "Memfasilitasi pelaksanaan family class", note: "" },
    { id: "2", text: "Memfasilitasi edukasi oleh DPJP dan PPA", note: "" },
    {
      id: "3",
      text: "Memfasilitasi konsultasi pasien dan keluarga kepada DPJP dan PPA",
      note: ""
    },
    { id: "4", text: "Melakukan kroscek coding diagnosa", note: "" },
    { id: "5", text: "Memfasilitasi plafon pembiayaan BPJS", note: "" },
    { id: "6", text: "Memfasilitasi pelaksanaan konferensi klinis", note: "" },
    {
      id: "7",
      text: "Mengidentifikasi faktor-faktor Penyebab LOS yang panjang",
      note: ""
    },
    {
      id: "8",
      text: "Melakukan koordinasi dengan DPJP adanya LOS yang panjang",
      note: ""
    },
    { id: "9", text: "Memfasilitasi komunikasi antar PPA", note: "" },
    {
      id: "10",
      text: "Memfasilitasi komunikasi dan menghadirkan keluarga",
      note: ""
    },
    {
      id: "11",
      text: "Memberikan motivasi kepada pasien dan keluarga",
      note: ""
    },
    { id: "12", text: "Memfasilitasi kebutuhan rohaniawan", note: "" },
    { id: "13", text: "Melakukan pendampingan", note: "" },
    {
      id: "14",
      text: "Melakukan koordinasi dengan Bidang Pelayanan",
      note: ""
    },
    {
      id: "15",
      text: "Melakukan koordinasi dengan dengan Admin ruangan",
      note: ""
    },
    {
      id: "16",
      text: "Mengadakan koordinasi dengan penjamin eksternal internal (IPP)",
      note: ""
    },
    { id: "17", text: "Memfasilitasi penjaminan BPJS", note: "" },
    { id: "18", text: "Memfasilitasi penjaminan Jasa Raharja", note: "" },
    { id: "19", text: "Memfasilitasi penjaminan ASABRI", note: "" },
    { id: "20", text: "Memfasilitasi penjaminan PT.Taspen", note: "" },
    { id: "21", text: "Memfasilitasi penjaminan Jamkesda/Jamkessos", note: "" },
    {
      id: "22",
      text: "Memfasilitasi aktivasi Kartu BPJS Kes/. BPJS Nakes dan Taspen",
      note: ""
    },
    {
      id: "23",
      text:
        "Memfasilitasi persyaratan jaminan asuransi kesehatan (Kronologi,/SPM/General konsen/ Pernmyataan jaminan)",
      note: ""
    },
    { id: "24", text: "Memfasilitasi altrenatif jaminan pembiayaan", note: "" },
    {
      id: "25",
      text: "Melakukan koordinasi dengan fasyankes wilayah setempat",
      note: ""
    },
    {
      id: "26",
      text: "Memfasilitasi keluarga untuk edukasi, Training perawatan mandiri",
      note: ""
    },
    {
      id: "27",
      text: "Memfasilitasi keluarga mencari alternatif home care",
      note: ""
    },
    {
      id: "28",
      text:
        "Berkoordinasi dengan dinas sosial berhubungan dengan pemulangan pasien",
      note: ""
    },
    {
      id: "29",
      text:
        "Melakukan koordinasi dengan DPJP dan PPA Lain berhubungan perencanaan pemulangan pasien",
      note: ""
    },
    {
      id: "30",
      text:
        "Melakukan penguraian penumpukan pasien di PPRI, IGD dan di ruang rawat inap",
      note: ""
    },
    {
      id: "31",
      text:
        "Melakukan koordinasi dengan DPJP untuk melakukan perawatan sementara sebelum mendapatkan tempat rujukan",
      note: ""
    },
    {
      id: "32",
      text:
        "Melakukan koordinasi dengan MPP Rumah sakit rujukan bila diperlukan",
      note: ""
    },
    {
      id: "33",
      text:
        "Melakukan koordinasi dengan PPA agar tidak terjadi duplikasi layanan untuk kendali biaya",
      note: ""
    },
    {
      id: "34",
      text:
        "Melakukan Kroscek kepastian jaminan pembiayaan sebelum tindakan medis dengan biaya tinggi dilakukan",
      note: ""
    },
    {
      id: "35",
      text:
        "Memastikan tindakan medis dengan biaya tinggi sudah sesuai koding jaminan dari asuransi kesehatan",
      note: ""
    },
    { id: "36", text: "Memfasilitasi home care", note: "" },
    { id: "99", text: "Lainnya", note: "" }
  ];

  optEvaluasi = [
    { id: "1", text: "Family Class terlaksana", note: "" },
    {
      id: "2",
      text:
        "Pasien dan atau keluarga sudah teredukasi tentang perkembangan kesehatannya",
      note: ""
    },
    { id: "3", text: "Plafon pembiayaan BPJS terbit di E-RM", note: "" },
    { id: "4", text: "Konfrensi klinis terlaksana", note: "" },
    {
      id: "5",
      text: "Faktor-faktor penyebab LOS panjang terdeteksi",
      note: ""
    },
    {
      id: "6",
      text: "Kesinambungan komunikasi antar PPA terlaksana",
      note: ""
    },
    { id: "7", text: "Kartu jaminan kesehatan pasien sudah aktif", note: "" },
    {
      id: "8",
      text: "Keluarga sudah terkomunikasi dan bersedia hadir ke RS",
      note: ""
    },
    { id: "9", text: "Sudah terlaksana pendampingan rohaniawan", note: "" },
    {
      id: "10",
      text:
        "Pasien sudah mendapatkan kepastian jaminan pembiayan dari BPJS / JR / ASABRI / Jamkessos / Jamkesda / Jaminan kesehatan lainnya",
      note: ""
    },
    { id: "11", text: "Sudah ada alternarif Pembiayaan lainnya", note: "" },
    { id: "12", text: "Perencanaan pasien pulang sudah terlaksana", note: "" },
    {
      id: "13",
      text: "Sudah Ada kepastian tindak lanjut dari fasyankes setempat",
      note: ""
    },
    {
      id: "14",
      text:
        "Tindakan medis dengan biaya tinggi sudah dikonsultasikan dengan IPP dan sesuai koding",
      note: ""
    },
    { id: "99", text: "Lainnya", note: "" }
  ];

  get filteredImplementasi() {
    if (!this.searchImplementasi) return this.optImplementasi;
    return this.optImplementasi.filter(item => {
      return item.text
        .toLowerCase()
        .includes(this.searchImplementasi.toLowerCase());
    });
  }

  get filteredEvaluasi() {
    if (!this.searchEvaluasi) return this.optEvaluasi;
    return this.optEvaluasi.filter(item => {
      return item.text
        .toLowerCase()
        .includes(this.searchEvaluasi.toLowerCase());
    });
  }

  get isValidForm() {
    return this.validationErrors.length === 0;
  }

  get validationErrors() {
    const errors: string[] = [];
    const hasImplementasi =
      this.selectedImplementasi && this.selectedImplementasi.length > 0;
    const hasEvaluasi =
      this.selectedEvaluasi && this.selectedEvaluasi.length > 0;

    if (!hasImplementasi && !hasEvaluasi) {
      errors.push("Pilih minimal satu data Implementasi atau Evaluasi.");
    }
    return errors;
  }

  get stateUser() {
    return userModule.user;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  mounted() {
    if (!this.listPerawat || this.listPerawat.length === 0) {
      storePerawat.actListPerawatall();
    }
  }

  @Watch("perawatId")
  onPerawatChange(val: any) {
    const found = this.listPerawat.find((p: any) => p.id === val);
    this.namaPerawat = found ? found.nama : "";
    if (this.isInternalChange) return;

    this.isInternalChange = true;
    this.$emit("input", this.sendData);
    this.$nextTick(() => {
      this.isInternalChange = false;
    });
  }

  @Watch("value", { immediate: true })
  onValueChange(val: any) {
   if (this.isInternalChange) return;
    if (!val) {
      this.resetForm();
      return;
    }
    this.getData(val);
  }
  
@Watch("selectedImplementasi")
@Watch("selectedEvaluasi")
@Watch("keterangan")
@Watch("authored_at")
onDataUpdated() {
  if (this.isInternalChange) return;

  this.isInternalChange = true;
  this.$emit("input", this.sendData);
  
  if (this.authored_at) {
    this.formError.authored_at = null;
  }

  this.$nextTick(() => {
    this.isInternalChange = false;
  });
}

@Watch("selectedImplementasi")
onImplementasiChange(val: string[]) {
  const idLainnya = "99";
  if (val.includes(idLainnya)) {
    this.$nextTick(() => {
      // Pastikan ref ada sebelum akses index 0
      const el = this.$refs.refNoteImp as any[];
      if (el && el[0]) el[0].focus();
    });
  } else {
    this.noteImplementasi = "";
  }
}

@Watch("selectedEvaluasi")
onEvaluasiChange(val: string[]) {
  const idLainnya = "99";
  if (val.includes(idLainnya)) {
    this.$nextTick(() => {
      const el = this.$refs.refNoteEva as any[];
      if (el && el[0]) el[0].focus();
    });
  } else {
    this.noteEvaluasi = "";
  }
}

  resetForm() {
  this.isInternalChange = true;
    this.id = null;
    this.perawatId = null;
    this.namaPerawat = "";
    this.selectedImplementasi = [];
    this.selectedEvaluasi = [];
    this.keterangan = "";
    this.noteImplementasi = "";
    this.noteEvaluasi = "";
    this.authored_at = new Date();

    // Reset unit & perawat ke default state saat ini
    this.unitRanapId = this.stateUser?.unit_id || null;
    this.unitRanap = this.stateUser?.unit || null;
    this.unit = {
      id: this.stateUser?.unit_id,
      nama: this.stateUser?.unit
    };
    this.user = {
      id: this.stateUser?.id,
      nama: this.stateUser?.nama
    };
    
        this.$nextTick(() => { 
      this.isInternalChange = false;
    });
  }


  get sendData() {
    return {
      id: this.id,
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: {
        id: this.unitRanapId || this.unit?.id,
        nama: this.unitRanap || this.unit?.nama || "-"
      },
      user: {
        id: this.user?.id || this.stateUser?.id,
        nama: this.user?.nama || this.stateUser?.nama || "-"
      },
      authored_at: moment(this.authored_at).format("YYYY-MM-DD HH:mm:ss"),
      category: this.category ? this.category : "implementasi",
      content: {
        perawat_id: this.perawatId || null,
        nama_perawat: this.namaPerawat || "",
        implementasi: this.selectedImplementasi.map(id => {
          const item = this.optImplementasi.find(opt => opt.id === id);
          return {
            id: item?.id || id,
            text: item?.text || "",
            note: item?.id === "99" ? this.noteImplementasi : ""
          };
        }),
        evaluasi: this.selectedEvaluasi.map(id => {
          const item = this.optEvaluasi.find(opt => opt.id === id);
          return {
            id: item?.id || id,
            text: item?.text || "",
            note: item?.id === "99" ? this.noteEvaluasi : ""
          };
        }),
        keterangan: this.keterangan || ""
      }
    };
  }

  getData(dataApi: any) {
    if (!dataApi) return;
    
     this.isInternalChange = true;

    this.id = dataApi.id || null;
    this.unit = dataApi.unit || {};
    this.user = dataApi.user || {};

    // Pastikan authored_at adalah object Date
    this.authored_at = dataApi.authored_at
      ? new Date(dataApi.authored_at)
      : new Date();

    this.category = dataApi.category || "implementasi";
    // 2. Map Content (Implementasi & Evaluasi)
    const data = dataApi.content || {};

    this.perawatId = data.perawat_id || null;
    this.namaPerawat = data.nama_perawat || "";

    const imp = data.implementasi || [];
    if (imp && Array.isArray(imp)) {
      this.selectedImplementasi = imp.map((item: any) => String(item.id));

      const itemLainnya = imp.find((item: any) => item.id === "99");
      this.noteImplementasi = itemLainnya ? itemLainnya.note : "";
    } else {
      this.selectedImplementasi = [];
      this.noteImplementasi = "";
    }

    const eva = data.evaluasi || [];
    if (eva && Array.isArray(eva)) {
      this.selectedEvaluasi = eva.map((item: any) => String(item.id));

      const itemLainnyaEva = eva.find((item: any) => item.id === "99");
      this.noteEvaluasi = itemLainnyaEva ? itemLainnyaEva.note : "";
    } else {
      this.selectedEvaluasi = [];
      this.noteEvaluasi = "";
    }

    this.keterangan = data.keterangan || "";
    
    this.$nextTick(() => {
      this.isInternalChange = false;
    });
  }

  

  datetimeInput() {
    const dtime = new Date();
    if (this.authored_at > dtime) {
      this.$nextTick(() => {
        this.authored_at = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  public validasi(): boolean {
  this.formError.authored_at = null;
  
  if (!this.authored_at) {
    this.formError.authored_at = "Tanggal & Jam Pencatatan wajib diisi";
    return false;
  }
  return true;
}
}
